module.exports = ".input-pais {\n  max-width: 100%; }\n\n.mat-expansion-panel-header {\n  min-width: 600px; }\n\n.codigo {\n  max-width: 100px; }\n"